import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import {
  fontFamilyEN as fontFamily,
  fontSize,
} from '../../../../styles/themes/vad/font';

const useStyles = makeStyles(theme => ({
  iternaryLayout: {
    '& .emptylistIternary': {
      ...theme.mixins.paddingLR('5.5%', '5.5%'),
      marginBottom: '64px',
      [theme.breakpoints.down('sm')]: {
        marginBottom: '32px',
      },
      '& .innerWrapper': {
        position: 'relative',
        padding: '74px 88px 67px',
        background: '#C9DBE4',
        overflow: 'hidden',
        [theme.breakpoints.down('lg')]: {
          padding: '54px 50px 47px',
        },
        [theme.breakpoints.down('sm')]: {
          background: 'transparent',
          padding: '0',
        },
        '& .subHeading': {
          marginBottom: pxToRem(16),
          color: '#003451',
          [theme.breakpoints.down('sm')]: {
            display: 'none',
          },
        },
        '& .mainHeading': {
          maxWidth: '95%',
          width: '100%',
          minHeight: '188px',
          color: '#003451',
          fontWeight: 700,
          marginBottom: pxToRem(17),
          [theme.breakpoints.down('lg')]: {
            minHeight: 'auto',
          },
        },
        '& .boxImage': {
          top: 0,
          ...theme.mixins.right(0),
          minHeight: '434px',
          minWidth: '454px',
          height: '100%',
          [theme.breakpoints.down('sm')]: {
            display: 'none',
          },
          position: 'absolute',
          '& svg': {
            height: '100%',
            maxWidth: '100%',
            maxHeight: '100%',
          },
        },
        '& .buttonWrapper': {
          [theme.breakpoints.down('sm')]: {
            display: 'none',
          },
          '& .viewButton': {
            ...theme.mixins.marginLeft(72),
          },
          '& .MuiButtonBase-root': {
            '& .MuiButton-label': {
              justifyContent: 'space-between',
              '& .MuiButton-endIcon': {
                ...theme.mixins.marginLeft(22),
              },
            },
            '& .btn-txt': {
              fontSize: pxToRem(22),
            },
          },
        },
        '& .mobileButtonWrapper': {
          display: 'none',
          [theme.breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'column',
          },

          '& .link': {
            display: 'flex',
            color: '#FF8707',
            margin: '8px 0',
            alignItems: 'center',
            fontSize: '16px',
            fontWeight: 700,
            '& .MuiTypography-body2Bold': {
              fontSize: '16px',
            },
            '& svg': {
              ...theme.mixins.marginRight(12.6),
            },
          },
        },
      },
    },
    '& .itenaryListing': {
      paddingTop: '51px',
      background: theme.mixins.milkWhite(200),
      display: 'flex',
      ...theme.mixins.paddingLR('5.5%', '5.5%'),
      [theme.breakpoints.down('md')]: {
        background: 'transparent',
        paddingTop: '0',
        ...theme.mixins.paddingLR(pxToRem(24), pxToRem(24)),
      },
      [theme.breakpoints.down('sm')]: {
        background: 'transparent',
        ...theme.mixins.paddingLR(pxToRem(0), pxToRem(0)),
      },
      '& .contentSection': {
        maxWidth: '24.621%',
        flex: '0 0 24.621%',
        position: 'relative',
        background: '#C9DBE4',
        padding: '40px 20px',
        overflow: 'hidden',
        [theme.breakpoints.down('md')]: {
          display: 'none',
        },
        [theme.breakpoints.up('xxl')]: {
          padding: '40px 24px',
        },
        '& .MuiTypography-root': {
          display: 'block',
          fontWeight: 700,
          width: '100%',
          maxWidth: '100%',
          marginBottom: pxToRem(38),
          color: '#003451',
          [theme.breakpoints.up('xxl')]: {
            maxWidth: '80%',
          },
        },
        '& .create-btn': {
          zIndex: 1,
          marginBottom: pxToRem(14),
          fontWeight: 700,
          display: 'flex',
        },
        '& .view-btn': {
          zIndex: 1,
          fontWeight: 700,
        },
        '& .bgImage': {
          zIndex: 0,
          position: 'absolute',
          height: '100%',
          top: '1px',
          ...theme.mixins.right(pxToRem(0)),
          '& svg': {
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
          },
        },
      },
      '& .sectionSlider': {
        maxWidth: '75%',
        flex: '0 0 75%',
        '& .mainHeading': {
          fontSize: pxToRem(32),
          lineHeight: pxToRem(40),
          marginBottom: pxToRem(32),
          display: 'block',
          [theme.breakpoints.down('md')]: {
            marginBottom: pxToRem(16),
          },
          [theme.breakpoints.down('sm')]: {
            ...theme.mixins.paddingLR(pxToRem(24), pxToRem(24)),
            fontSize: pxToRem(22),
            lineHeight: pxToRem(32),
          },
        },
        [theme.breakpoints.down('md')]: {
          ...theme.mixins.marginLeft(pxToRem(0)),
          maxWidth: '100%',
          flex: '0 0 100%',
          marginBottom: pxToRem(32),
        },
        '& .innerBox': {
          height: '100%',
          ...theme.mixins.marginLeft(pxToRem(24)),
          [theme.breakpoints.down('md')]: {
            ...theme.mixins.marginLeft(pxToRem(0)),
          },
          '& .slick-slider': {
            height: 'auto',
            [theme.breakpoints.up('lg')]: {
              height: 'calc(100% - 57.6px)',
            },
            [theme.breakpoints.up('xxl')]: {
              height: 'calc(100% - 72px)',
            },
            '[dir="rtl"] &': {
              [theme.breakpoints.down('md')]: {
                direction: 'rtl',
              },
            },

            '& .slick-prev , & .slick-next': {
              width: 'auto',
              height: 'auto',
              zIndex: 10,
              '&.slick-disabled': {
                opacity: 0,
              },
              '& .MuiButtonBase-root': {
                width: pxToRem(56),
                height: pxToRem(56),

                '& .MuiIconButton-label': {
                  '& .MuiSvgIcon-root': {
                    width: pxToRem(17),
                  },
                },
                '&:hover': {
                  backgroundColor: 'rgb(255, 135, 7)',
                  borderColor: 'rgb(255, 135, 7)',

                },
              },
              '&::before': {
                display: 'none',
              },
            },
            '& .slick-next': {
              ...theme.mixins.right(pxToRem(-20)),
              '[dir="rtl"] &': {
                ...theme.mixins.left(pxToRem(-26)),
                ...theme.mixins.right('auto'),
              },
            },
            '& .slick-prev': {
              ...theme.mixins.left(pxToRem(-28)),
              '[dir="rtl"] &': {
                ...theme.mixins.right(pxToRem(-18)),
                ...theme.mixins.left('auto'),
              },
            },
            '& .slick-list': {
              height: '100%',
              [theme.breakpoints.down('md')]: {
                overflowX: 'auto',
                overflowY: 'unset',
              },
              '& .slick-track': {
                height: '100%',
                display: 'flex',
                ...theme.mixins.marginLeft(pxToRem(0)),
                [theme.breakpoints.down('md')]: {
                  paddingBottom: '16px',
                  transform: 'translate3d(0px, 0px, 0px) !important',
                  '[dir="rtl"] &': {
                    [theme.breakpoints.down('md')]: {
                      flexDirection: 'row-reverse',
                    },
                  },
                },
                [theme.breakpoints.down('sm')]: {
                  ...theme.mixins.marginLeft('auto'),
                },
                '& .slick-slide': {
                  height: 'auto',
                  ...theme.mixins.paddingRight(pxToRem(12)),
                  '& div': {
                    height: '100%',
                  },
                  '& .sliderInner': {
                    cursor: 'pointer',
                    height: '100%',
                    backgroundColor: '#fff',
                    boxShadow: '0px 2px 20px 0px rgba(0, 0, 0, 0.03)',
                    '&.rtlClass': {
                      direction: 'rtl',
                    },
                    [theme.breakpoints.down('md')]: {
                      display: 'flex !important',
                      boxShadow: 'none',
                    },
                    '& .imageWrapper': {
                      backgroundColor: '#FCEFDE',
                      maxHeight: '218px',
                      overflow: 'hidden',
                      [theme.breakpoints.down('md')]: {
                        flex: '0 0 95px',
                        maxWidth: '95px',
                        maxHeight: '95px',
                      },
                      '&.show-placeholder-img': {
                        minHeight: '218px',
                        [theme.breakpoints.down('md')]: {
                          minHeight: '95px',
                        },
                        '& picture': {
                          minHeight: '218px',
                          [theme.breakpoints.down('md')]: {
                            minHeight: '95px',
                          },
                          '& img': {
                            minHeight: '218px',
                            [theme.breakpoints.down('md')]: {
                              minHeight: '95px',
                            },
                          },
                        },
                      },
                      '& picture': {
                        maxHeight: '218px',
                        [theme.breakpoints.down('md')]: {
                          maxHeight: '95px',
                        },
                        '& img': {
                          maxHeight: '218px',
                          [theme.breakpoints.down('md')]: {
                            maxHeight: '95px',
                          },
                        },
                      },
                    },
                    '& .contentWrapper': {
                      padding: '24px 17px 22px',
                      [theme.breakpoints.down('md')]: {
                        padding: '0px 16px 0px',
                      },
                      '& .titleHead': {
                        fontSize: pxToRem(22),
                        wordBreak: 'break-word',
                        [theme.breakpoints.down('md')]: {
                          fontSize: pxToRem(16),
                          lineHeight: '24px',
                        },
                      },
                      '& .titleSmall': {
                        display: 'flex',
                        marginTop: pxToRem(12),
                        fontSize: '14px',
                        lineHeight: '24px',
                        color: '#706C6C',
                        [theme.breakpoints.down('md')]: {
                          marginTop: pxToRem(8),
                        },
                        alignItems: 'center',
                        '& svg': {
                          ...theme.mixins.marginRight(pxToRem(5)),
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          '& .mobileButtonWrapper': {
            display: 'none',
            [theme.breakpoints.down('md')]: {
              display: 'flex',
              flexDirection: 'column',
            },
            [theme.breakpoints.down('sm')]: {
              ...theme.mixins.paddingLR(pxToRem(24), pxToRem(24)),
            },

            '& .link': {
              display: 'flex',
              color: '#FF8707',
              margin: '8px 0',
              alignItems: 'center',
              fontSize: '16px',
              fontWeight: 700,
              [theme.breakpoints.down('sm')]: {
                '[dir="rtl"] &': {
                  [theme.breakpoints.down('md')]: {
                    flexDirection: 'row-reverse',
                    justifyContent: 'flex-end',
                  },
                },
              },
              '&:last-child': {
                marginBottom: pxToRem(0),
              },
              '& .MuiTypography-body2Bold': {
                fontSize: '16px',
              },
              '& svg': {
                ...theme.mixins.marginRight(12.6),
                [theme.breakpoints.down('sm')]: {
                  '[dir="rtl"] &': {
                    [theme.breakpoints.down('md')]: {
                      ...theme.mixins.marginRight(0),
                      ...theme.mixins.marginLeft(12.6),
                      transform: 'rotate(180deg)',
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
}));

export default useStyles;